module.exports = __webpack_public_path__ + "assets/img/delivery-sm.6f49b12b.jpg";